<template>
  <div>
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 작업허가서 구분</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">회사명</div>
        <span v-if="isPrint"> {{ form.inputA_1 }} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_1" :readonly="true"/>
      </div>
      <div class="col-start-1 col-span-6 flex items-center">
        <div class="label-text mr-4">작업명</div>
        <span v-if="isPrint"> {{ form.inputA_2 }} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_2" :readonly="board.readonly"/>
      </div>
      <div class="col-span-12 flex items-center">
        <div class="label-text mr-4">작업구분</div>
        <span v-if="isPrint"> {{ form.categoryLabel }} </span>
        <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>
          <vs-checkbox
            v-for="checkbox in optionCheckBox"
            v-model="form.category"
            v-bind:key="checkbox.id"
            :vs-value="checkbox.id"
            @change="onCheck($event)"
            class="mr-1 mb-2"
            :readonly="board.readonly">
            {{ checkbox.label }}
          </vs-checkbox>
        </div>
      </div>
      <div class="col-start-1 col-span-6 flex items-center">
        <div class="label-text mr-4">허가번호</div>
        <span v-if="isPrint"> {{ form.inputA_3 }} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_3" :readonly="board.readonly"/>
      </div>
      <div class="col-start-1 col-span-6 flex items-center">
        <div class="label-text mr-4">허가일자</div>
        <span v-if="isPrint"> {{ form.inputA_4 }} </span>
        <date-selector v-else class="w-full flex-1" v-model="form.inputA_4" :readonly="board.readonly"/>
      </div>
      <div class="col-start-1 col-span-6 flex items-center">
        <div class="label-text mr-4">소속</div>
        <span v-if="isPrint"> {{ form.inputA_5 }} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_5" :readonly="true"/>
      </div>
      <div class="col-start-1 col-span-6 flex items-center">
        <div class="label-text mr-4">부서</div>
        <span v-if="isPrint"> {{ form.inputA_0 }} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_0" :readonly="true"/>
      </div>
      <div class="col-start-1 col-span-6 flex items-center">
        <div class="label-text mr-4">신청부서 연락처</div>
        <span v-if="isPrint"> {{ form.inputA_6 }} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_6" :readonly="board.readonly"/>
      </div>
      <div class="col-start-1 col-span-7 flex items-center">
        <div class="label-text mr-4">작업 허가기간</div>
        <span v-if="isPrint"> {{ form.inputA_7 }} - {{ form.inputA_8 }} </span>
        <div v-else class="flex flex-1 items-center">
          <div class="flex-1">
            <date-selector class="w-full" v-model="form.inputA_7" :readonly="board.readonly"/>
          </div>
          <div class="ml-4 mr-4">~</div>
          <div class="flex-1">
            <date-selector class="w-full" v-model="form.inputA_8" :readonly="board.readonly"/>
          </div>
        </div>
      </div>
      <div v-if="!isPrint" class="col-span-3 flex items-center">
        <vs-checkbox
          v-model="form.inputA_9"
          :readonly="board.readonly">
          반복작업
        </vs-checkbox>
      </div>
      <div class="col-start-1 col-span-7 flex items-center">
        <div class="label-text mr-4">일일 작업 시간</div>
        <span v-if="isPrint"> {{ form.inputA_10 }} - {{ form.inputA_11 }} </span>
        <div v-else class="flex flex-1 items-center">
          <div class="flex-1">
            <time-selector class="w-full" v-model="form.inputA_10" :readonly="board.readonly"/>
          </div>
          <div class="ml-4 mr-4">~</div>
          <div class="flex-1">
            <time-selector class="w-full" v-model="form.inputA_11" :readonly="board.readonly"/>
          </div>
        </div>
      </div>
      <div class="col-span-12 flex items-center">
        <div class="label-text mr-4">작업개요</div>
        <span v-if="isPrint"> {{ form.inputA_10 }} </span>
        <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputA_12" :readonly="board.readonly"/>
      </div>
      <div class="col-span-12 flex items-center">
        <div class="label-text mr-4">첨부서류</div>
        <span v-if="isPrint"> {{ labelDocumentAttached }} </span>
        <div v-else class=" flex flex-wrap w-full flex-1">
          <vs-checkbox
            v-for="checkbox in listdocumentAttached"
            v-model="form.documentAttached"
            v-bind:key="checkbox.id"
            :vs-value="checkbox.id"
            class="mr-4 mb-2"
            :readonly="board.readonly">
            {{ checkbox.label }}
          </vs-checkbox>
        </div>
      </div>
    </div>

    <table-safe
      :dataCheckbox="checkboxSelected"
      :list="form.list"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
      @update-list-check="updateListCheck"></table-safe>
    <vs-row style="padding: 1rem 0rem;">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 기타 특별사항 및 안전조치 확인</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12">
      <div class="col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">기타 특별사항</div>
        <span v-if="isPrint"> {{ form.inputB_1 }} </span>
        <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_1" :readonly="board.readonly"/>
      </div>
      <div class="col-span-12 flex items-center">
        <div class="label-text mr-4 ">안전조치 확인</div>
        <div class=" mr-4">현장 책임자(대리인)</div>
        <div class="col-span-3 flex items-center mr-4">
          <div class="mr-4">소속</div>
          <span v-if="isPrint"> {{ form.inputB_2 }} </span>
          <ml-input v-else class="flex-1" v-model="form.inputB_2" :readonly="board.readonly"/>
        </div>
        <div class="col-span-2 flex items-center">
          <div class="mr-4">성명</div>
          <span v-if="isPrint"> {{ form.inputB_3 }} </span>
          <ml-input v-else class="flex-1" v-model="form.inputB_3" :readonly="board.readonly"/>
        </div>
      </div>
    </div>

    <div class="vs-row" style="padding: 1rem 0rem;">
      <div class="grid-cols-12 row-header">
        <div class="col-span-12 row-header__item">
          <feather-icon
            icon="AlertTriangleIcon"
            class="ml-1"
            style="width:18px; height:18px;margin-right: 5px"/>
          주의사항
        </div>
      </div>
      <div class="grid-cols-12">
        <div class="col-span-12 row-content__body">
          <div class="grid-cols-12 row-content__body-item">
            <strong>1. 현장 책임자(대리인)는 작업 전 안전조치 확인 후 서명 날인 하며 본 허가서를 작업 현장에 비치 또는 게시하도록 한다.<br/></strong>
            2. 본 안전작업 허가서의 유효기간은 <strong>허가기간으로</strong> 제한한다.<br/>
            3. 안전조치 미흡 및 위반사항 발생 시 작업자 퇴출 또는 작업 중단 조치한다.<br/>
            4. 현장 책임자(대리인)는 작업에 대한 안전상 책임이 있으며 작업종료 후 종료 <strong>일시를 기재</strong>하여 허가서를 관련 부서에 반납한다.<br/>
          </div>
        </div>
      </div>
    </div>
    <div class="vs-row" style="padding: 1rem 0rem;">
      <vs-row class="mb-4">
        <vs-col><h5><i class="dot"></i>작업완료 일시(수기작성)</h5></vs-col>
      </vs-row>
      <div class="vs-row">
        <div class="grid grid-cols-12 row-content">
          <div class="col-span-2 row-content__title">
            작업완료 일시
          </div>
          <div class="col-span-4 row-content__body"/>
          <div class="col-span-2 row-content__title">
            현장 책임자(대리인)
          </div>
          <div class="col-span-4 row-content__body">
            <pre>성명:                (서명)</pre>
          </div>
        </div>
      </div>
    </div>
    <file-upload-module class="w-full" v-if="!isPrint" v-model="form.fileList" :readonly="board.readonly"/>
  </div>
</template>

<script>
import DateSelector from '@/components/selector/DateSelector'
import TableSafe from '@/components/TableSafe.vue'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TimeSelector from '@/components/selector/TimeSelector'

export default {
  name: 'Write',
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  computed: {
    listdocumentAttached () {
      return [
        {
          id: '1',
          label: '안전작업허가 요청서'
        },
        {
          id: '2',
          label: '안전작업계획서'
        },
        {
          id: '3',
          label: '자격'
        },
        {
          id: '4',
          label: '특수건강검진'
        },
        {
          id: '5',
          label: '안전보건교육'
        },
        {
          id: '6',
          label: '도면'
        },
        {
          id: '7',
          label: '사전 위험성 평가'
        },
        {
          id: '8',
          label: '기타'
        }
      ]
    },

    optionCheckBox () {
      return [
        {
          id: 'label_1',
          label: '화기작업',
          dataTable: [
            {
              text: '작업구역 설정(출입경고 표지)',
              index: 1
            },
            {
              text: '위험물질(가연성분진포함)방출 및 처리',
              index: 2
            },
            {
              text: '개인보호구 착용',
              index: 3
            },
            {
              text: '비산 불티 차단막 설치',
              index: 4
            },
            {
              text: '작업주위 가연성물질 제거',
              index: 5
            },
            {
              text: '소화기 비치',
              index: 6
            },
            {
              text: '가스농도 측정',
              index: 7
            },
            {
              text: '안전장비 구비',
              index: 8
            },
            {
              text: '차량 등의 출입제한',
              index: 9
            },
            {
              text: '안전교육 실시',
              index: 10
            }
          ]
        },
        {
          id: 'label_2',
          label: '밀폐공간작업',
          dataTable: [
            {
              text: '작업구역 설정(출입경고 표지)',
              index: 1
            },
            {
              text: '용기 내부 세정 및 처리',
              index: 2
            },
            {
              text: '개인보호구 착용',
              index: 3
            },
            {
              text: '불활성가스 치환 및 환기',
              index: 4
            },
            {
              text: '작업주위 가연성물질 제거',
              index: 5
            },
            {
              text: '환기 및 조명장비 설치',
              index: 6
            },
            {
              text: '가스농도 측정',
              index: 7
            },
            {
              text: '통신장비 및 안전장비 구비',
              index: 8
            },
            {
              text: '맹판설치 및 표지부착',
              index: 9
            },
            {
              text: '안전교육 실시',
              index: 10
            },
            {
              text: '용기개방 및 압력방출',
              index: 11
            },
            {
              text: '현장 책임자 배치',
              index: 12
            }
          ]
        },
        {
          id: 'label_3',
          label: '전기작업',
          dataTable: [
            {
              text: '작업구역 설정(출입경고 표지)',
              index: 1
            },
            {
              text: '담당작업자 및 전기담당자 배치',
              index: 2
            },
            {
              text: '개인보호구 착용',
              index: 3
            },
            {
              text: '소화기 비치',
              index: 4
            },
            {
              text: '전원 차단 및 표지부착',
              index: 5
            },
            {
              text: '안전장비 구비',
              index: 6
            },
            {
              text: '잔류전기 확인',
              index: 7
            },
            {
              text: '안전교육 실시',
              index: 8
            },
            {
              text: '기계·설비 운전 정지',
              index: 9
            },
            {
              text: '현장 책임자 배치',
              index: 10
            }
          ]
        },
        {
          id: 'label_4',
          label: '고소작업',
          dataTable: [
            {
              text: '작업안내 표지 설치',
              index: 1
            },
            {
              text: '추락방지망 설치',
              index: 2
            },
            {
              text: '개인보호구 착용',
              index: 3
            },
            {
              text: '안전장비 구비',
              index: 4
            },
            {
              text: '작업 발판 및 안전난간 설치',
              index: 5
            },
            {
              text: '안전교육 실시',
              index: 6
            },
            {
              text: '안전대 착용·부착',
              index: 7
            },
            {
              text: '현장 책임자 배치',
              index: 8
            }
          ]
        },
        {
          id: 'label_5',
          label: '잠수작업',
          dataTable: [
            {
              text: '작업안내 표지(잠수 깃발)',
              index: 1
            },
            {
              text: '낮은 수온에서 장시간 작업 금지',
              index: 2
            },
            {
              text: '장비 상태 점검',
              index: 3
            },
            {
              text: '장시간 작업 후 상승 시 안전 감압 실시',
              index: 4
            },
            {
              text: '기상 상황 점검',
              index: 5
            },
            {
              text: '감시원 배치',
              index: 6
            },
            {
              text: '개인보호구 착용',
              index: 7
            },
            {
              text: '공기압축기 작동 및 호스 꼬임 확인',
              index: 8
            },
            {
              text: '고농도 산소 제한',
              index: 9
            },
            {
              text: '보조 공기통 지급',
              index: 10
            },
            {
              text: '잠수사 건강상태 점검',
              index: 11
            },
            {
              text: '안전장비 구비',
              index: 12
            },
            {
              text: '버디 설정',
              index: 13
            },
            {
              text: '안전교육 실시',
              index: 14
            },
            {
              text: '상승·하강 속도 준수',
              index: 15
            },
            {
              text: '현장 책임자 배치',
              index: 16
            }
          ]
        },
        {
          id: 'label_6',
          label: '인공어초 제작 및 설치작업',
          dataTable: [
            {
              text: '작업안내 표지 설치',
              index: 1
            },
            {
              text: '크레인 작업반경 내 접근 금지',
              index: 2
            },
            {
              text: '장비 상태 점검',
              index: 3
            },
            {
              text: '작업 발판 및 안전난간 설치',
              index: 4
            },
            {
              text: '기상 상황 점검',
              index: 5
            },
            {
              text: '안전대 착용·부착',
              index: 6
            },
            {
              text: '개인보호구 착용',
              index: 7
            },
            {
              text: '안전장비 구비',
              index: 8
            },
            {
              text: '작업자 건강상태 점검',
              index: 9
            },
            {
              text: '안전교육 실시',
              index: 10
            },
            {
              text: '작업지휘자 및 유도자(신호수) 배치',
              index: 11
            },
            {
              text: '현장 책임자 배치',
              index: 12
            }
          ]
        },
        {
          id: 'label_7',
          label: '자연석 선적 및 시설작업',
          dataTable: [
            {
              text: '작업안내 표지 설치',
              index: 1
            },
            {
              text: '작업지휘자 및 유도자(신호수) 배치',
              index: 2
            },
            {
              text: '장비 상태 점검',
              index: 3
            },
            {
              text: '굴착기 작업반경 내 접근 금지',
              index: 4
            },
            {
              text: '기상 상황 점검',
              index: 5
            },
            {
              text: '안전장비 구비',
              index: 6
            },
            {
              text: '개인보호구 착용',
              index: 7
            },
            {
              text: '안전교육 실시',
              index: 8
            },
            {
              text: '작업자 건강상태 점검',
              index: 9
            },
            {
              text: '현장 책임자 배치',
              index: 10
            }
          ]
        },
        {
          id: '8',
          label: '갯벌 작업',
          dataTable: [
            {
              text: '기상 상황 및 물때표 점검',
              index: 1
            },
            {
              text: '위치 파악을 위한 원색 의복 착용',
              index: 2
            },
            {
              text: '장비 상태 점검',
              index: 3
            },
            {
              text: '비상연락망 숙지',
              index: 4
            },
            {
              text: '개인보호구 착용',
              index: 5
            },
            {
              text: '안전장비 구비',
              index: 6
            },
            {
              text: '작업자 건강상태 점검',
              index: 7
            },
            {
              text: '안전교육 실시',
              index: 8
            },
            {
              text: '작업 주변 유해·위험요인(갯골 등) 확인',
              index: 9
            },
            {
              text: '현장 책임자 배치',
              index: 10
            }
          ]
        }
      ]
    },

    labelDocumentAttached () {
      const listLabel = this.form.documentAttached.reduce((e, i) => {
        let label = this.listdocumentAttached.find((n) => n.id === i).label
        e.push(label)
        return e
      }, [])
      return listLabel.join(',')
    }
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (value) {
        this.form.inputA_0 = this.value && this.value.inputA_0 ? this.value.inputA_0 : this.board.writer.com_name
        this.form.inputA_1 = this.value && this.value.inputA_1 ? this.value.inputA_1 : this.board.projectTitle
        this.form.inputA_5 = this.value && this.value.inputA_5 ? this.value.inputA_5 : this.board.writer.department
      }
    },
    value (value) {
      const keys = Object.keys(this.form)
      for (const key of keys) {
        this.form[key] = value[key]
      }

      // Load table and image
      let objCheckBoxSelected = this.optionCheckBox.find((n) => n.label === this.form.categoryLabel)
      if (objCheckBoxSelected) {
        this.checkboxSelected = objCheckBoxSelected
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        value.title = value.inputA_1
        value.summary = {
          작업구분: [],
        }
        value.summary['작업구분'].push( {[this.form.categoryLabel]: 1} )
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      form: {
        list: [],
        documentAttached: [],
        category: [],
        categoryLabel: '',
        inputA_0: '',
        inputA_1: '',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',
        inputA_5: '',
        inputA_6: '',
        inputA_7: '',
        inputA_8: '',
        inputA_9: '',
        inputA_10: '',
        inputA_11: '',
        inputA_12: '',
        inputB_1: '',
        inputB_2: '',
        inputB_3: '',
        fileList: []
      },
      checkboxSelected: []
    }
  },
  methods: {
    updateListCheck (indexRows, text) {
      this.form.list[indexRows].is_checked = text
    },
    onCheck (value) {
      this.form.category = [value[value.length - 1]]
      if (this.form.category[0]) {
        this.form.categoryLabel = this.optionCheckBox.filter(x => x.id == this.form.category)[0].label
        let objSelected = this.optionCheckBox.filter(x => x.id == this.form.category[0])[0]
        this.checkboxSelected = objSelected
        let temp = []
        objSelected.dataTable.forEach(element => {
          temp.push(
            {
              text: element.text,
              is_checked: ''
            }
          )
        })
        this.form.list = temp
      } else {
        this.checkboxSelected = {}
      }
    }
  },
  components: {
    DateSelector,
    TableSafe,
    FileUploadModule,
    TimeSelector
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  margin-right: 16px;
}

.grid {
  padding-top: 1rem;
}

.row-header {
  background-color: $bg;
  text-align: center;
  height: 50px;
}

.row-header__item {
  border: $border;
  border-left: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .vs-icon {
    font-size: 1rem;
  }
}

.row-header__item.item-col {
  flex-direction: column;
}

.row-header__item:last-child {
  border-right: none;
}

.row-content {
  justify-content: center;
  line-height: 50px;
  padding-top: 0;
  border: $border;

  &__title {
    background-color: $bg;
    text-align: center;
    border-right: $border;
    border-left: $border;
  }

  &__title:first-child {
    border-left: none;
  }
}

.row-content__body-item {
  padding: 20px;
  border-bottom: $border;
}

</style>
